import { X, AlertCircle, CheckCircle, AlertTriangle } from 'lucide-react';

export default function Toast({ message, type = 'error', visible = false, onClose }) {
  if (!visible) return null;

  const typeConfig = {
    error: {
      bg: 'bg-red-50',
      border: 'border-red-200',
      icon: 'text-red-600',
      text: 'text-red-600',
      button: 'text-red-400 hover:text-red-600'
    },
    success: {
      bg: 'bg-green-50',
      border: 'border-green-200',
      icon: 'text-green-600',
      text: 'text-green-600',
      button: 'text-green-400 hover:text-green-600'
    },
    warning: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-200',
      icon: 'text-yellow-600',
      text: 'text-yellow-600',
      button: 'text-yellow-400 hover:text-yellow-600'
    }
  };

  const config = typeConfig[type];
  const IconComponent = type === 'success' ? CheckCircle : type === 'warning' ? AlertTriangle : AlertCircle;

  return (
    <div className={`p-4 rounded-xl border flex items-center gap-3 animate-slide-down ${config.bg} ${config.border}`}>
      <IconComponent className={`w-5 h-5 flex-shrink-0 ${config.icon}`} />
      <p className={`text-sm font-medium flex-1 ${config.text}`}>{message}</p>
      <button
        onClick={onClose}
        className={`flex-shrink-0 p-1 rounded hover:bg-black/10 transition ${config.button}`}
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
}
